import React from "react";

export default function Help() {
  return <div></div>;
}
